import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularSplitModule } from 'angular-split';
import { FullCalendarModule } from '@fullcalendar/angular';

import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';

import { CallComponent } from './call/call.component';
import { NavbarComponent } from './navbar/navbar.component';
import { LoginComponent } from './login/login.component';
import { ErrorModalComponent } from './alert/error-modal.component';
import { ErrorbarComponent } from './errorbar/errorbar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TimerComponent } from './timer/timer.component';
import { DocsComponent } from './docs/docs.component';
import { FutureDateTimeValidatorDirective } from './validators/futuredatetime.directive';

import { WsService } from './ws/ws.service';
import { AlertService } from './alert/alert.service';
import { SipService } from './sip/sip.service';
import { WorkflowService } from './workflow/workflow.service';
import { StatService } from './stat/stat.service';
import { ErrorService } from './errorbar/error.service';

import { DurationPipe } from './pipes/duration.pipe';

import { FormsModule } from '@angular/forms';
import { ScriptComponent } from './call/script/script.component';

export class DefaultIntl extends OwlDateTimeIntl {
    cancelBtnLabel='Отмена';
    setBtnLabel='Выбрать';
};

@NgModule({
  declarations: [
    AppComponent,
    CallComponent,
    NavbarComponent,
    LoginComponent,
    ErrorModalComponent,
    ErrorbarComponent,
    DashboardComponent,
    TimerComponent,
    DocsComponent,
    DurationPipe,
    FutureDateTimeValidatorDirective,
    ScriptComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FullCalendarModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    AngularSplitModule.forRoot(),
    FormsModule
  ],
  providers: [
    WsService,
    SipService,
    WorkflowService,
    AlertService,
    ErrorService,
    StatService,
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'ru'},
    {provide: OwlDateTimeIntl, useClass: DefaultIntl},
  ],
  entryComponents: [
    ErrorModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts